// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__UQCvs","errorLogs":"styles_errorLogs__m2Jah"};